<template>
  <BaseDialogForm
    :title="`${tripModule.trip} Summary`"
    v-model="showTripSummaryForm"
    maxWidth="40%"
  >
    <template #content>
      <v-row class="ma-0">
        <v-col cols="12" md="6">
          <DatePicker
            id="date"
            type="date"
            outlined
            label="Select Date"
            v-model="selectedDate"
            :max="returnToday()"
          />
        </v-col>
        <v-col cols="12" md="6" class="d-flex justify-end align-center">
          <PrimaryButton
            id="tripSummaryExport"
            @click="getTripSummary"
            name="Export"
          >
          </PrimaryButton>
        </v-col>
      </v-row>
    </template>
  </BaseDialogForm>
</template>

<script>
import BaseDialogForm from "@/components/LayoutComponents/BaseDialogForm.vue";
import { bus } from "@/main";
import { downloadBlob, returnToday } from "@/utils/functions";
import { tripModule } from "@/utils/moduleMapping";

export default {
  components: { BaseDialogForm },
  emits: ["refreshDetails"],
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    tripObj: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    value(val) {
      if (val) {
        this.selectedDate = returnToday();
      }
    },
  },
  data() {
    return {
      tripModule,
      returnToday,
      selectedDate: null,
    };
  },
  computed: {
    showTripSummaryForm: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    profileObject() {
      let obj = localStorage.getItem("user_data");
      return obj ? JSON.parse(obj) : null;
    },
  },
  methods: {
    getTripSummary() {
      bus.$emit("showLoader", true);
      let params = {
        branch: this.profileObject.preferred_branch.id,
        trip_date: this.selectedDate,
      };
      this.$api.trip
        .getTripSummary(params)
        .then((res) => {
          downloadBlob(res.data, `${returnToday()} Trip Summary`, ".xlsx");
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          if (err.data) {
            this.formErrors = err.data;
          }
          bus.$emit("showLoader", false);
        });
    },
  },
};
</script>

<style></style>
